import React from "react";

export default function WalletNew() {
  return (
    <svg
      width="23"
      height="18"
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="10.7734"
        y="4.99121"
        width="10.5"
        height="7.94444"
        rx="1.25"
        stroke="white"
        stroke-width="1.5"
      />
      <rect
        x="0.773438"
        y="1.21387"
        width="20.5"
        height="15.5"
        rx="2.25"
        stroke="#F4F4F4"
        stroke-width="1.5"
      />
    </svg>
  );
}
